import intlMessageDE from '../il8n/locales/de.json';
import intlMessageEN from '../il8n/locales/en.json';
import intlMessageES from '../il8n/locales/es.json';
import intlMessageFR from '../il8n/locales/fr.json';
import intlMessageHI from '../il8n/locales/hi.json';
import intlMessageIT from '../il8n/locales/it.json';
import intlMessageJP from '../il8n/locales/ja.json';
import intlMessagePT from '../il8n/locales/pt.json';
import intlMessageRO from '../il8n/locales/ro.json';
import {StoreKeys} from '../utils/StoreKeys'

export function getLocale() {
    const baseInitializationParams = JSON.parse(localStorage.getItem(StoreKeys.BASE_INITIALIZATION_PARAMS));
    const locale = baseInitializationParams && baseInitializationParams.userPreferences && baseInitializationParams.userPreferences.locale ?
        baseInitializationParams.userPreferences.locale : "en";
    switch (locale) {
        case "de":
        case "de-CH":
        case "de-AT":
        case "de-LU":
        case "de-LI":
            return "de"
        case "es":
        case "es-AR":
        case "es-GT":
        case "es-CR":
        case "es-PA":
        case "es-DO":
        case "es-MX":
        case "es-VE":
        case "es-CO":
        case "es-PE":
        case "es-EC":
        case "es-CL":
        case "es-UY":
        case "es-PY":
        case "es-BO":
        case "es-SV":
        case "es-HN":
        case "es-NI":
        case "es-PR":
            return "es"
        case "fr":
        case "fr-BE":
        case "fr-CA":
        case "fr-CH":
        case "fr-LU":
            return "fr"
        case "hi":
        case "hi-IN":
            return "hi"
        case "it":
        case "it-CH":
            return "it"
        case "ja":
            return "ja"
        case "pt":
        case "pt-BR":
        case "pt-PT":
            return "pt"
        case "ro":
        case "ro-RO":
            return "ro"
        default:
            return "en"
    }
}

export function getMessages() {
    const locale = getLocale();
    switch (locale) {
        case "de":
            return intlMessageDE
        case "es":
            return intlMessageES
        case "fr":
            return intlMessageFR
        case "hi":
            return intlMessageHI
        case "it":
            return intlMessageIT
        case "ja":
            return intlMessageJP
        case "pt":
            return intlMessagePT
        case "ro":
            return intlMessageRO
        default:
            return intlMessageEN
    }
}


// WEBPACK FOOTER //
// ./src/components/handler/LocaleHandler.js